<div class="container-full bg-theme">
  <div class="container">
    <div class="columns">
      <div class="column is-12">
        <app-breadcrumbs
          [darkTheme]="true"
          [breadcrumbLinks]="breadcrumbLinks">
        </app-breadcrumbs>
        <h1 i18n="@@aboutTitle" class="title is-1 has-text-light">
            About OECD.AI
        </h1>
      </div>
    </div>
  </div>
</div>
